import { useModuleConfigSchemaValuesQuery } from '../request/admin/queries';
import { GetSchemaValuesArgs } from '../request/admin/moduleConfigRequests';

export function useModuleConfigurations(args: GetSchemaValuesArgs) {
  return useModuleConfigSchemaValuesQuery(args);
}
